var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternal)?_c('div',_vm._b({staticClass:"svg-external-icon svg-icon",style:(_vm.styleExternalIcon)},'div',_vm.$attrs,false)):_c('svg',_vm._b({class:_vm.svgClass,attrs:{"aria-hidden":"true"}},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }